import React, { useState, useEffect } from "react";
import { timeDiffCalc } from "utils/utils";
import { useUser } from "reactfire";
import { doc } from "firebase/firestore";
import { useLeague } from "context/leagueContext";
import { useTranslation } from "react-i18next";
import { useFirestore, useFirestoreDocData } from "reactfire";
import RoundTab from "components/roundTab";
const RegularTab = ({ roundData }) => {
  const {
    state: { leagueInfo, nextRoundId, leagueUserData },
  } = useLeague();
  const { status, data: user } = useUser();
  const { t } = useTranslation();
  const firestore = useFirestore();
  const [userRoundData, setUserRoundData] = useState(undefined);
  const [roundInfo, setRoundInfo] = useState(undefined);

  /* 
  Get user info for league.
   */
  const userRoundDataRef = doc(
    firestore,
    "userTournaments/" +
      leagueInfo?.id +
      "/rounds/" +
      roundData?.id +
      "/users/",
    user?.uid
  );
  const { status: userLeagueDataStatus, data: userRoundDataDoc } =
    useFirestoreDocData(userRoundDataRef);
  useEffect(() => {
    if (userRoundDataDoc) {
      setUserRoundData(userRoundDataDoc);
    }
  }, [userRoundDataDoc]);

  const roundInfoRef = doc(
    firestore,
    "userTournaments/" + leagueInfo?.id + "/rounds/",
    roundData?.id
  );
  const { status: roundInfoStatus, data: roundInfoDoc } =
    useFirestoreDocData(roundInfoRef);
  useEffect(() => {
    if (roundInfoDoc) {
      setRoundInfo(roundInfoDoc);
    }
  }, [roundInfoDoc]);

  let time = timeDiffCalc(
    new Date(roundData?.deadline?.seconds * 1000),
    new Date().getTime()
  );

  let labelStatus, label, roundContent, roundName;

  if (leagueInfo?.scoreRule == 6 || leagueInfo?.scoreRule == 8) {
    roundContent = userRoundData?.roundPoints
      ? userRoundData?.roundPoints + "p"
      : "-";
  } else if (leagueInfo?.gameType == 0 || leagueInfo?.gameRule == 4) {
    roundContent =
      userRoundData?.points > 0
        ? leagueInfo?.scoreRule == 2
          ? userRoundData?.points.toFixed(1) + "p"
          : userRoundData?.points + "p"
        : !time
        ? "0p"
        : "-";
  }

  if (leagueInfo?.gameType == 0) {
    roundName = roundData?.name
      ? t("tournament.roundtab.round") + " " + roundData?.name
      : "-";

    label = roundInfo?.settled
      ? t("tournament.roundtab.settled")
      : time
      ? time
      : t("tournament.roundtab.ongoing");
  } else if (
    leagueInfo?.gameRule == 3 ||
    leagueInfo?.gameRule == 4 ||
    leagueInfo?.gameRule == 2
  ) {
    roundName = t("tournament.roundtab.round") + " " + (roundData?.pos + 1);

    if (roundInfo?.settled) {
      if (leagueUserData?.exitRound == roundData?.id) {
        labelStatus = 3;
        label = "Eliminated";
      } else if (
        leagueUserData?.passedRounds?.some((el) => el === roundData?.id)
      ) {
        labelStatus = 1;
        label = "Passed";
      } else {
        labelStatus = null;
        label = "Settled";
      }
    } else {
      label = time ? time : t("tournament.roundtab.ongoing");
    }
  }

  return (
    <RoundTab
      id={roundInfo?.id}
      header={roundName}
      title={roundContent}
      label={label}
      settled={roundInfo?.settled}
      highlighted={nextRoundId === roundData?.id}
      labelStatus={labelStatus}
    />
  );
};

export default RegularTab;
